let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("51CzE")).then(() => parcelRequire('lQpoo'));